module.exports = __webpack_public_path__ + "static/img/lasting_impressions_banner_3.6a2b3b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lasting_impressions_banner_3.jpg
// module id = 706
// module chunks = 1